export default __webpack_public_path__ + "static/media/genero.c8bdd857.png";